<!-- <p>visitor-timeline works!</p> -->

<mat-card
  [ngClass]="{
    'incident-table-card': screenSize == ScreenType.Desktop,
    'incident-table-card-tablet': screenSize == ScreenType.Tablet,

    'incident-table-card-mobile': screenSize == ScreenType.Mobile
  }"
>
  <mat-card-header
    [ngClass]="{
      'incident-table-card-header':
        screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

      'incident-table-card-header-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <div
      [ngClass]="{
        'incident-table-header':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

        'incident-table-header-mobile': screenSize == ScreenType.Mobile
      }"
    >
      <h3>Visitor Timeline</h3>
    </div>
  </mat-card-header>
  <mat-card-content class="incident-table-card-content">
    <div class="visitors-table">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="index">
          <th
            style="text-align: center; border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
          >
            No.
          </th>
          <td
            style="text-align: center; border-right: 1px solid"
            mat-cell
            *matCellDef="let element"
          >
            {{ rowIndex - element.index }}
          </td>
        </ng-container>
        <ng-container matColumnDef="checkin">
          <th
            style="text-align: center; border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
          >
            Check In
          </th>
          <td
            style="text-align: center; border-right: 1px solid"
            mat-cell
            *matCellDef="let element"
          >
            {{ getFormatedDate(element.checkIn) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="checkout">
          <th style="text-align: center" mat-header-cell *matHeaderCellDef>
            Check Out
          </th>
          <td style="text-align: center" mat-cell *matCellDef="let element">
            {{
              element.checkOut == "0001-01-01T00:00:00"
                ? "Pending"
                : getFormatedDate(element.checkOut)
            }}
          </td>
        </ng-container>
        <!-- <ng-container matColumnDef="date">
          <th
            style="text-align: center; border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
          >
            Date
          </th>
          <td
            style="text-align: center; border-right: 1px solid"
            mat-cell
            *matCellDef="let element"
          >
            {{ element | date : "fullDate" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="time">
          <th style="text-align: center" mat-header-cell *matHeaderCellDef>
            Time
          </th>
          <td style="text-align: center" mat-cell *matCellDef="let element">
            <b>{{ element | date : "hh:mm:ss a" }}</b>
          </td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div class="data-not-found" *ngIf="!rowIndex">
        {{ "No timeline available" | uppercase }}
      </div>
    </div>
  </mat-card-content>
</mat-card>
